import repository from "@/api/modules/Operations/WPF";

export default {
    state: {
        // export_pending_so_list_report: []
    },
    getters: {
        // GET_PENDING_SO_LIST_REPORT: (state) => state.export_pending_so_list_report
    },
    actions: {
        postWPF({commit},payload) {
            return new Promise((resolve, reject) => {
                repository.wpfpost(payload).then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                    }
                }).catch((error) => {
                    reject(error)
                });
            })
        },
        putWPF({commit},payload) {
            return new Promise((resolve, reject) => {
                repository.wpfput(payload).then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                    }
                }).catch((error) => {
                    reject(error)
                });
            })
        },
        deleteWPF({commit},payload) {
            return new Promise((resolve, reject) => {
                repository.wpfdelete(payload).then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                    }
                }).catch((error) => {
                    reject(error)
                });
            })
        },
        getWPF({commit},payload) {
            return new Promise((resolve, reject) => {
                repository.wpfget(payload).then((response) => {
                    if (response.status == 200) {
                        resolve(response)
                    }
                }).catch((error) => {
                    reject(error)
                });
            })
        }
    },
    mutations: {
        // PENDING_SO_LIST_REPORT: (state, data) => { (state.export_pending_so_list_report = data) }
    }

}
